export class BoxFormatModel {
  boxPattern: number
  boxClassName: string

  boxTopHeading: string
  boxTopHeading_tablet: string
  boxTopHeading_mobile: string
  boxTopSubHeading: string
  boxTopHeadingDetail: string

  boxHeading: string
  boxHeading_tablet: string
  boxHeading_mobile: string
  boxSubHeading: string
  boxHeadingDetail: string

  boxImageWebP: string
  boxImage: string
  boxImageType: string
  boxImageAlt: string

  boxBtnText: string
  boxBtnLinkName: string

     boxBtnRouteNamePath?: string
    boxBtnRouteNameSubPath?: string

}

export enum BoxPatternEnum {
  textLeftImageRight = 1,
  textRightImageLeft = 2,
}

export enum AccountingFirmType {
  All = 0,
  AccountingFirm = 1,
  Freelance = 2,
}

export enum AccountingFirmRegion {
  All = 'ALL',
  BangkokAndSurroundingAreas = 'BKK',
  NorthEast = 'NE',
  North = 'N',
  South = 'S',
  Central = 'C',
  East = 'E',
  West = 'W'
}

export enum AccountingFirmDisplayType {
  Recommend = 'recommend',
  Partner = 'partner'
}
